<mat-form-field [ngClass]="{'open': auto.isOpen}">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <input type="text"
         #autocompleteInput
         matInput
         [formControl]="formControl"
         [placeholder]="placeholder"
         [matAutocomplete]="auto"
         (input)="onInputChange($event)">
  <mat-autocomplete #auto="matAutocomplete"
                    [displayWith]="withObjects ? displayFn : null"
                    (optionSelected)="onOptionSelected($event)">
    <mat-option *ngFor="let option of filteredOptions"
                [value]="option">
      {{withObjects ? option[displayField] : option}}
    </mat-option>
  </mat-autocomplete>
  <mat-icon *ngIf="isSearch; else arrowDropDown" matSuffix class="search-icon">search</mat-icon>
  <ng-template #arrowDropDown>
    <mat-icon matSuffix>arrow_drop_down</mat-icon>
  </ng-template>
</mat-form-field>
<app-form-error-list *ngIf="showErrors && !auto.isOpen" [errorMap]="formControl.errors"></app-form-error-list>
